import { render, staticRenderFns } from "./indexPage.vue?vue&type=template&id=f4a78ee4&scoped=true&"
import script from "./indexPage.vue?vue&type=script&lang=js&"
export * from "./indexPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a78ee4",
  null
  
)

export default component.exports